module.exports = __webpack_public_path__ + "static/img/so6_2.06aa0d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so6_2.jpg
// module id = zMwd
// module chunks = 11